import { Enum } from 'enumify';

class AutosaveType extends Enum {}

AutosaveType.initEnum(['IMMEDIATE', 'DELAYED', 'FLUSH']);

export default AutosaveType;
